<template>
  <div>
    <v-card>
      <v-app-bar class="transparent" light flat>
        <v-toolbar-title>
          <v-btn icon @click="$router.push('/users/identifiants#superviseurs')">
            <v-icon>mdi-arrow-left</v-icon> </v-btn
          >Projets de
          {{ $route.params.superviseur.displayName }}</v-toolbar-title
        >
      </v-app-bar>

      <v-card-text>
        <v-card
          v-if="$route.params.superviseur.projets.length > 0"
          class="mb-4 pa-4"
          light
        >
          <v-list two-line subheader>
            <v-list-item
              v-for="(item, index) in $route.params.superviseur.projets"
              :key="index"
            
            >
              <v-list-item-avatar>
                <v-icon class="primary white--text">mdi-chart-gantt</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-text="item.ll_programme"
                ></v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    goToProgrammesDuProjet(item) {
      this.$router.push({
        path: `/groupes/groupesFromProjetsRegional/${item}?uid=${this.$route.params.superviseur.uid}&displayName=${this.$route.params.superviseur.displayName}`,
      });
    },
  },
  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
